import { media, spacing } from '@gyym/ui'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const List = styled.ul`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-gap: ${spacing(4)};
  justify-content: center;

  ${media.pc} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

export const Item = styled.li``
